import { applyMiddleware, createStore, StoreEnhancer } from "redux";
import { rootReducer } from "./RootReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import { Logger } from "./Logger";
import { MonitorReducerEnhancer } from "./MonitorReducer";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistStore, persistReducer, PersistConfig } from "redux-persist";
import React from "react";

const persistConfig: PersistConfig = {
  key: "root",
  storage,
  whitelist: [
    "login",
    "session",
    "settingsMarketsGrid",
    "settingsColours"
  ]
};

export function configureStore(preloadedState: any) {
  const persistingRootReducer = persistReducer(persistConfig, rootReducer);
  let middlewares: any[];
  let enhancers: any[];
  if (process.env.NODE_ENV === "development") {
    middlewares = [Logger];
  } else {
    middlewares = [];
    enhancers = [];
  }
  const middlewareEnhancer = applyMiddleware(...middlewares);
  if (process.env.NODE_ENV === "development") {
    enhancers = [middlewareEnhancer, MonitorReducerEnhancer];
  } else {
    enhancers = [];
  }

  const composedEnhancers = composeWithDevTools(...enhancers) as StoreEnhancer;

  const store = createStore(
    persistingRootReducer,
    preloadedState,
    composedEnhancers
  );
  return store;
}

const configuredStore = configureStore(undefined);

export const StoreProvider: React.FunctionComponent<React.PropsWithChildren<{}>> = props => {
  const { children } = props;
  return (
    <Provider store={configuredStore}>
      <PersistGate loading={null} persistor={persistStore(configuredStore)}>
        {children}
      </PersistGate>
    </Provider>
  );
};
